import { useTranslation } from "react-i18next";

/** CH− / CH+ buttons for the player header. */
export function ZapButtons({ onPrev, onNext }: { onPrev: () => void; onNext: () => void }) {
  const { t } = useTranslation();
  const cls =
    "h-8 w-8 inline-flex items-center justify-center rounded border border-border text-text/80 " +
    "hover:border-accent hover:text-text focus-visible:border-accent tv:h-10 tv:w-10";
  return (
    <span className="inline-flex gap-1">
      <button type="button" onClick={onPrev} className={cls} aria-label={t("previous_channel")} title={t("previous_channel")}>
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden>
          <path d="m15 18-6-6 6-6" />
        </svg>
      </button>
      <button type="button" onClick={onNext} className={cls} aria-label={t("next_channel")} title={t("next_channel")}>
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden>
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>
    </span>
  );
}
